// import {USER_ERROR, USER_SUCCESS, USER_REQUEST} from '../actions/user'
// import {AUTH_LOGOUT} from '../actions/auth'
// import {ACCOUNT_REQUEST} from '../actions/account'
// import apiCall from '@/utils/api.js'
// import Vue from 'vue'
// import G from 'glob'
// import axios from 'axios'
// import { stat } from 'fs'
// import { Store } from 'vuex'


import { mock, contactData } from '../../utils/mockdata';

var axios = require('axios');
// var MockAdapter = require('axios-mock-adapter');

// // This sets the mock adapter on the default instance
// var mock = new MockAdapter(axios);


export default {

    state: {
        contacts: [],
        selectedContact: {}
    }, 
    getters: {
        allContacts: (state) => state.contacts,
        // filteredContacts: (state, getters) => (searchstring) => {
        //     console.log('got searchstring > '+searchstring)
        //     // console.log(  state.contacts.find(contact => contact.name.includes(searchstring)) )
        //     // var res = state.contacts.find(contact)
        //     // var res = state.contacts.find(contact => contact.name.toLowerCase().includes(searchstring.toLowerCase))
        //     // console.log(JSON.stringify(res))
        //     if (state.contacts!=null && state.contacts.length >0) {
        //         return state.contacts.filter(contact => contact.name.toLowerCase().includes(searchstring.toLowerCase))
        //     }
        //     return []
        //     // return filterByValue(state.contacts, searchstring)
        // }, 
        // filteredContacts: (state) => (searchstring) => {
        //     console.log('got searchstring > '+searchstring)
        //     // console.log(  state.contacts.find(contact => contact.name.includes(searchstring)) )
        //     // var res = state.contacts.find(contact)
        //     // var res = state.contacts.find(contact => contact.name.toLowerCase().includes(searchstring.toLowerCase))
        //     // console.log(JSON.stringify(res))
        //     // if (state.contacts!=null && state.contacts.length >0) {
        //     //     return state.contacts.filter(contact => contact.name.toLowerCase().includes(searchstring.toLowerCase))
        //     // }
        //     // return []

        //     // var res = state.contacts.filter(contact => contact.name.toLowerCase().includes(searchstring.toLowerCase()))
        //     // console.log(JSON.stringify(res))
        //     return state.contacts.find(contact => contact.name.toLowerCase().includes(searchstring.toLowerCase()))

        //     // return filterByValue(state.contacts, searchstring)
        // }, 
        // filteredContacts: (state) => {
        //     if (state.contacts!=null && state.contacts.length >0) {
        //         return state.contacts.filter(contact => contact.name.toLowerCase().includes('net'))    
        //     }
        //     return []
        // },
        // getMovieById: (state, getters) => (id) => {
        //     return state.movies.find(movie => movie.id === id)
        //   },
        // getTodoById: (state) => (id) => {
        //     return state.todos.find(todo => todo.id === id)
        //   }
        selectedContact: (state) => state.selectedContact
    },
    
    actions: {
        // async fetchContacts({commit}) {
        //     const response = await axios.get(
        //         'https://jsonplaceholder.typicode.com/users'
        //     );
        //     console.log("contacts fetched.")
        //     commit('setContacts', response.data)
        // },
        async fetchContacts({commit}) {
            // await apiCall({url: 'contacts'})
            // .then(resp => commit('setContacts', resp.data))
            // console.log("contacts fetched.")
            
            // let user = {id: '1'}
            console.log("contacts fetching..." + contactData.length)

            mock.onGet('/contacts').reply(
                200, {data: contactData}
                // function(config) {
                //     // console.log("purchases ... " + JSON.stringify(config))
                //     return [200, {data: contactData}]
                // }
              );
              
              
            axios.get('/contacts')
                // .then(function(response) {
                //     console.log(response.data);
                //     commit('setPurchases', response.data)
                // });
            .then(resp => {
                commit('setContacts', resp.data.data),
                console.log("contacts fetched. > #" + resp.data.data.length)
            });


        },
        // async fetchFilteredContacts({commit}, filterstring) {
        //     console.log("action> fetchFilteredContacts: "+ filterstring)

        // }, 
        async updateContact({commit}, contact) {
            // const response = await axios.post(
            //     'https://jsonplaceholder.typicode.com/users',
            //     // {'data': contact})
            //     contact)
            // commit('updateContact', response.data)
            commit('updateContact', contact)
        },
        putSelectedContact({commit}, contact) {
            if (contact!=null && !contact.hasOwnProperty('status')) {
                contact.status = {custtotal: 0, custvalue: '', custrel: '', custclass: '', lastcontact: '', tags: []}
            }
            commit('setSelectedContact', contact)
        },
        addNewContact({commit}, contact) {
            commit('addNewContact', contact)
        }, 
        deleteContact({commit}, contact) {
            commit('deleteContact', contact)
        }
    },
    mutations: {
        setContacts: (state, contacts) => (state.contacts = contacts),
        setSelectedContact: (state, contact) => (state.selectedContact = contact),
        updateContact: (state, updcontact) => {
            // pushToArray(state.contacts, contact) //... NOT WORKING properly

            const index = state.contacts.findIndex(contact => contact.id === updcontact.id)
            if (index !== -1) {
                state.contacts.splice(index, 1, updcontact)
            }
            // console.log("... > "+ JSON.stringify(updcontact))
        },
        addNewContact: (state, addcontact) => state.contacts.unshift(addcontact),
        deleteContact: (state, delcontact) => {
            const index = state.contacts.findIndex(contact => contact.id === delcontact.id)
            if (index !== -1) {
                state.contacts.splice(index, 1)
            }
        }
    },
    
}


//.. ISSUE .. this here caused update issues
// function pushToArray(arr, obj) {
//     const index = arr.findIndex((e) => e.id === obj.id);

//     if (index === -1) {
//         arr.push(obj);
//     } else {
//         arr[index] = obj;
//         // arr.splice(index, 1, obj)
//     }
// }


// function filterByValue(array, string) {
//     return array.filter(o =>
//         Object.keys(o).some(k => o[k].toLowerCase().includes(string.toLowerCase())));
// }

// == Default structure ==
// export default {
//     state: {},
//     mutations: {},
//     actions: {},
//     getters: {}
// }